import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetInspectionDetail = async (id) => {
  return Request.call({
    url: `/micro/inspection/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiCreateInspection = async (data) => {
  const { isPublished = false } = data;

  return Request.call({
    url: `/micro/inspections${!isPublished ? '/draft' : ''}`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiUpdateInspection = async (data, id) => {
  // const { isPublished = false } = data;
  return Request.call({
    url: `/micro/inspections/${id}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDownloadInspectionReport = async (inspectionId, poItems) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/generate-report`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDownloadInspectionSplitReport = async (inspectionId, poItems) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/split-report`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      items: poItems,
    },
  });
};
export const apiGetInspectionPOItems = async (inspectionId, params = {}) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/po-items`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params,
  });
};
export const apiGetInspectionPOItemDetails = async (poItemId) => {
  return Request.call({
    url: `/micro/inspections/po-items/${poItemId}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetInspectionPOItemDocuments = async (jobId, poItemId, params) => {
  return Request.call({
    url: `/micro/inspections/${jobId}/po-items/${poItemId}/documents`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params,
  });
};
export const apiConfirmQuote = async (id, quoteId) => {
  return Request.call({
    url: `/micro/third-party/inspections/${id}/quotes/${quoteId}/confirm`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {},
  });
};
